export const FIREBASE_OFF_QUERY = 'FIREBASE_OFF_QUERY';
export const FIREBASE_ON_QUERY = 'FIREBASE_ON_QUERY';



// WEBPACK FOOTER //
// ./src/common/lib/redux-firebase/actions.js